<template>
    <div class="widget client-publish-widget">
        <div class="widget-header">
            <h3>Partner Resources for {{ clientName }}</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>Please select which resources you would like this partner to have:</p>
            <resource-select @select="selectResourceType($event)" />
            <div v-show="resourceType === 'Campaigns'">
                <template-published-client-table
                    :agencyId="agencyId"
                    :clientId="clientId"
                    @update:selectedItems="updateSelectedCampaigns($event)"
                ></template-published-client-table>
            </div>
            <div v-show="resourceType === 'Emails'">
                <email-template-published-client-table
                    :agencyId="agencyId"
                    :clientId="clientId"
                    @update:selectedItems="updateSelectedEmails($event)"
                ></email-template-published-client-table>
            </div>
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" :onClick="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button :onClick="save" :loading="isSaving">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ResourceSelect = () => import('@/components/common/resource-select');
const TemplatePublishedClientTable = () => import('@/components/template/template-published-client-table');
const EmailTemplatePublishedClientTable = () => import('@/components/email-template/email-template-published-client-table');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'client-publish-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'resource-select': ResourceSelect,
        'template-published-client-table': TemplatePublishedClientTable,
        'email-template-published-client-table': EmailTemplatePublishedClientTable,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            clientName: null,
            clientId: null,
            agencyId: null,
            resourceType: null,
            selectedCampaigns: [],
            selectedEmails: []
        }
    },

    computed: {

    },

    methods: {
        selectResourceType(resourceType) {
            this.resourceType = resourceType;
        },

        updateSelectedCampaigns(selectedCampaigns) {
            this.selectedCampaigns = selectedCampaigns;
        },

        updateSelectedEmails(selectedEmails) {
            this.selectedEmails = selectedEmails;
        },

        save() {  
            this.isSaving = true;
            var templateIds = this.selectedCampaigns.map(campaign => { return campaign.id });
            var emailTemplateIds = this.selectedEmails.map(email => { return email.id });

            var request = {
                clientId: this.clientId,
                templateIds: templateIds,
                emailTemplateIds: emailTemplateIds,
                agencyId: this.agencyId
            };

            this.$api
                .post(`/api/SharedAssets/Publish`, request)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your publish settings have been updated.');
                    
                    EventBus.$emit('update-shared-assets');
                    this.closeWidget();
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while saving your publish settings.', { error });
                })
                .finally(() => {
                    this.isSaving = false;
                });          
        },

        getClient() {
            this.$api
                .get(`/service/Clients/?$filter=Id eq ${ this.clientId }`)
                .then(response => {
                    this.clientName = response.data.value[0].Name;                 
                    this.isInitializing = false;
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while getting your template settings.', { error });
                    this.closeWidget();
                    this.isInitializing = false;
                }); 
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.clientId = this.options.clientId;
        this.agencyId = this.options.agencyId;
        this.getClient();
    },

    destroyed() {
        
    }
}
</script>

<style scoped>
.client-publish-widget .saving-step {
    text-align: center;
}

.client-publish-widget .content-wrapper {
    padding: 20px;
}

.client-publish-widget .action-container {
    display: flex;
}

.client-publish-widget .action-container .btn {
    margin-left: 15px;
}

.client-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.client-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.client-publish-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}

.client-publish-widget .resource-select {
    position: relative;
    z-index: 10000;
}
</style>
